import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '男同网站',
    url: 'https://www.nantongwangzhan.com',
    description: '专为男同群体打造的安全、友好的线上社区平台，提供交友、资讯、活动与支持服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
      email: 'contact@nantongwangzhan.com',
      availableLanguage: 'Chinese',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '男同网站',
    url: 'https://www.nantongwangzhan.com',
    description: '专为男同群体打造的安全、友好的线上社区平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.nantongwangzhan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '男同网站 - 专属男同社区与交友平台',
    description: '男同网站是专为男同群体打造的安全、友好的线上社区平台，提供交友、资讯、活动与支持服务。',
    url: 'https://www.nantongwangzhan.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '男同网站',
      url: 'https://www.nantongwangzhan.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <StatsBar />
          <CategoryGrid />
          <FeaturedArticles />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}